import { type FC } from 'react';

import { EmptyStateMessage } from '@/src/components/molecules/EmptyStateMessage';

export const NoResultsFoundDisplay: FC = () => (
  <EmptyStateMessage
    illustrationVariant='directions'
    isImage
    subTitle='Adjust your search terms and try again.'
    title='No Results Found'
  />
);
